var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navigation'),_c('div',{staticClass:"pt-50px"},[_c('router-view')],1),_c('portal-target',{attrs:{"name":"modal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }